import clsx from 'clsx';
import { Fragment } from 'react';

import { abbreviateFullName } from '@/modules/rankings/ppr/helpers';

interface MedalistDisplayProps {
  label: string;
  name: string;
  isPlayer: boolean;
  playerName: string;
}

export const MedalistDisplay = ({ label, name, isPlayer, playerName }: MedalistDisplayProps) => {
  if (!name) return null;

  if (isPlayer && name.includes('/')) {
    const parts = name.split('/').map((p) => p.trim());
    const input = playerName.toLowerCase().trim();
    const playerPartIndex = parts.findIndex((p) => p.toLowerCase().includes(input));
    if (playerPartIndex > 0) {
      const playerPart = parts.splice(playerPartIndex, 1)[0];
      if (playerPart) {
        parts.unshift(playerPart);
      }
    }
    return (
      <div className='flex items-center'>
        <p className='mr-1'>{label}:</p>
        <p>
          {parts.map((part, i) => {
            const isCurrent = part.toLowerCase().includes(input);
            return (
              <Fragment key={part}>
                <span className={clsx(isCurrent ? 'font-bold' : 'font-normal')}>
                  <span className='sm:hidden'>{abbreviateFullName(part)}</span>
                  <span className='hidden sm:inline'>{part}</span>
                </span>
                {i < parts.length - 1 ? ' / ' : ''}
              </Fragment>
            );
          })}
        </p>
      </div>
    );
  }

  return (
    <div className='flex items-center'>
      <p className='mr-1'>{label}:</p>
      <p className={clsx(isPlayer ? 'font-bold' : 'font-normal')}>
        <span className='sm:hidden'>{abbreviateFullName(name)}</span>
        <span className='hidden sm:inline'>{name}</span>
      </p>
    </div>
  );
};
